export const TON_PROTOCOL = 'ton://';
export const TONCONNECT_PROTOCOL = 'tc://';
export const TONCONNECT_PROTOCOL_SELF = 'twallet-tc://';
export const SELF_PROTOCOL = 'twallet://';
export const SELF_UNIVERSAL_URLS = ['https://my.tt', 'https://go.twallet.ae'];
export const TONCONNECT_UNIVERSAL_URL = 'https://connect.twallet.ae';
export const CHECKIN_URL = 'https://checkin.twallet.ae';
export const WALLETCONNECT_PROTOCOL = 'wc:';
export const WALLETCONNECT_DEEPLINK = 'twallet-wc://';
export const WALLETCONNECT_UNIVERSAL_URLS = ['https://connect.twallet.ae/wc'];
